import { render, staticRenderFns } from "./questionCorrection.vue?vue&type=template&id=66340d12"
import script from "./questionCorrection.vue?vue&type=script&lang=js"
export * from "./questionCorrection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports